var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoResource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1395 8.02613C22.6773 8.58639 22.6591 9.4766 22.0989 10.0145L16.2395 15.6395C15.6953 16.1619 14.8359 16.1619 14.2918 15.6395L10.7761 12.2645C10.2159 11.7266 10.1977 10.8364 10.7356 10.2761C11.2734 9.71586 12.1636 9.6977 12.7239 10.2356L15.2656 12.6756L20.1511 7.98555C20.7114 7.4477 21.6016 7.46586 22.1395 8.02613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.03125 9C0.03125 4.08121 4.01871 0.09375 8.9375 0.09375H27.6875C29.4997 0.09375 30.9688 1.56282 30.9688 3.375V31.5C30.9688 33.3122 29.4997 34.7812 27.6875 34.7812H7.0625C3.17925 34.7812 0.03125 31.6333 0.03125 27.75V9ZM2.84375 22.1245C4.0189 21.2418 5.47962 20.7188 7.0625 20.7188H28.1562V3.375C28.1562 3.11612 27.9464 2.90625 27.6875 2.90625H8.9375C5.57202 2.90625 2.84375 5.63452 2.84375 9V22.1245ZM2.84375 27.75C2.84375 30.08 4.73255 31.9688 7.0625 31.9688H27.6875C27.9464 31.9688 28.1562 31.7589 28.1562 31.5V23.5312H7.0625C4.73255 23.5312 2.84375 25.42 2.84375 27.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResource);
export default __webpack_public_path__ + "static/media/ico-resource.894d5bdd92d9255f5db0f50873c90f75.svg";
export { ForwardRef as ReactComponent };